/**
 *  @class
 *  @function VariantCardsV2
 *  Featured product (v2): selecting a variant card updates the product forms, gallery slide,
 *  price and installments. Add to cart itself is handled by Vision's <product-form> (product.js).
 */
if (!customElements.get('variant-cards-v2')) {
  class VariantCardsV2 extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      const input = event.target;
      if (input.type !== 'radio') return;

      this.querySelectorAll('.fpv2-variant').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));

      document
        .querySelectorAll(`#product-form-${this.sectionId} [name="id"], #product-form-installment-${this.sectionId} [name="id"]`)
        .forEach((field) => {
          field.value = input.value;
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });

      this.selectMedia(input.dataset.mediaId);
      this.renderVariant(input.value);
    }

    selectMedia(mediaId) {
      if (!mediaId) return;
      const slider = document.querySelector(`#MediaGallery-${this.sectionId} product-slider`);
      const selector = `#Slide-${this.sectionId}-${mediaId}`;
      if (slider && slider.querySelector(selector) && typeof slider.selectCell === 'function') {
        slider.selectCell(selector);
      }
    }

    renderVariant(variantId) {
      fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          [`price-${this.sectionId}`, `installments-${this.sectionId}`].forEach((id) => {
            const source = html.getElementById(id);
            const destination = document.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });

          const sourceButton = html.querySelector(`#product-form-${this.sectionId} .single-add-to-cart-button`);
          const button = document.querySelector(`#product-form-${this.sectionId} .single-add-to-cart-button`);
          if (sourceButton && button) {
            button.disabled = sourceButton.disabled;
            button.classList.toggle('sold-out', sourceButton.classList.contains('sold-out'));
            const label = button.querySelector('.single-add-to-cart-button--text');
            const sourceLabel = sourceButton.querySelector('.single-add-to-cart-button--text');
            if (label && sourceLabel) label.textContent = sourceLabel.textContent;
          }
        })
        .catch((error) => console.error(error));
    }
  }
  customElements.define('variant-cards-v2', VariantCardsV2);
}
